import { render, staticRenderFns } from "./PlayerReservations.vue?vue&type=template&id=e6b0baa6&scoped=true&"
import script from "./PlayerReservations.vue?vue&type=script&lang=js&"
export * from "./PlayerReservations.vue?vue&type=script&lang=js&"
import style0 from "./PlayerReservations.vue?vue&type=style&index=0&id=e6b0baa6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6b0baa6",
  null
  
)

export default component.exports